var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMerchantIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3569",
    "data-name": "Rectangle 3569",
    width: 70,
    height: 70,
    transform: "translate(0.285)",
    fill: "#019244"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10205",
    "data-name": "Group 10205",
    transform: "translate(-0.321 -0.036)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10204",
    "data-name": "Group 10204",
    transform: "translate(0.036 0.036)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32412",
    "data-name": "Path 32412",
    d: "M15.3,5.511A2.376,2.376,0,0,0,12.784,3H7.761A2.376,2.376,0,0,0,5.25,5.511,2.376,2.376,0,0,0,7.761,8.023h5.023A2.376,2.376,0,0,0,15.3,5.511",
    transform: "translate(12.294 7.01)",
    fill: "#019244"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32413",
    "data-name": "Path 32413",
    d: "M62.787,25.115H45.207V7.534A7.408,7.408,0,0,0,37.672,0H7.534A7.408,7.408,0,0,0,0,7.534V62.787a7.408,7.408,0,0,0,7.534,7.534h17.58a2.511,2.511,0,1,0,0-5.023H7.534a2.376,2.376,0,0,1-2.511-2.511V7.534A2.376,2.376,0,0,1,7.534,5.023H37.672a2.376,2.376,0,0,1,2.511,2.511v17.58H32.649a7.408,7.408,0,0,0-7.534,7.534V52.741a7.408,7.408,0,0,0,7.534,7.534h7.534V65.3H35.161a2.511,2.511,0,1,0,0,5.023H60.276a2.511,2.511,0,1,0,0-5.023H55.253V60.276h7.534a7.408,7.408,0,0,0,7.534-7.534V32.649a7.408,7.408,0,0,0-7.534-7.534M50.23,65.3H45.207V60.276H50.23ZM65.3,52.741a2.376,2.376,0,0,1-2.511,2.511H32.649a2.376,2.376,0,0,1-2.511-2.511V32.649a2.376,2.376,0,0,1,2.511-2.511H62.787A2.376,2.376,0,0,1,65.3,32.649Z",
    transform: "translate(-0.036 -0.036)",
    fill: "#019244"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMerchantIcon2);
export default __webpack_public_path__ + "static/media/merchant-icon2.15a10ea538cc7e2b5713b99a206d905b.svg";
export { ForwardRef as ReactComponent };